export default "__VITE_ASSET__B4y4A3ap__"